export default "__VITE_ASSET__8a289592__"